module.exports = __webpack_public_path__ + "static/media/zen_logo.184b7ba3.svg";